export default {
  searchPlaceholder: "Search for specific tag",
  selectedTags: "Selected Tags",
  doesNotExist: "Doesn't Exist",
  setupBrand: "Setup Brand Tags",
  title: "What's your brand known for?",
};
